<template>
  <div class="attachments">
    <input
      ref="hiddenInput"
      type="file"
      multiple
      hidden
      accept=".doc,.docx,.pdf,.xls,.xlsx,.jpg,.jpeg,.png,.txt"
      @change="handleFilesUploaded"
    />

    <div class="header">
      <div class="left">
        <AttachmentSvg />
        Attachments
      </div>
      <q-btn
        :ripple="false"
        size="sm"
        class="q-pa-sm"
        flat
        dense
        color="primary"
        icon="fas fa-plus"
        @click="$refs.hiddenInput.click()"
      />
    </div>
    <q-separator />
    <div v-if="files.length" class="uploaded-files">
      <FilePreview v-for="(file, index) of files" :key="index" :file="file" @delete="deleteFile(index, file)" />
    </div>
    <span v-if="!files.length">No attachments</span>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'
import * as apiTo from '../api'
import { mapState } from 'vuex'
// Components
import AttachmentSvg from '@/reusable/svg-icons/AttachmentSvg'
import FilePreview from './FilePreview'

export default {
  components: {
    AttachmentSvg,
    FilePreview
  },

  props: {
    editItem: Object,
    media: Array,
    fromPage: String
  },

  data: () => ({
    files: [],
    filesFromTemplate: []
  }),

  computed: {
    ...mapState('todo-modal', ['selectedTemplate'])
  },

  watch: {
    media: {
      handler(val) {
        if (this.editItem) this.files = cloneDeep(val)
        else this.files = []
      }
    },

    selectedTemplate(template) {
      this.files = cloneDeep(template.media)
      this.filesFromTemplate = cloneDeep(template.media)
    }
  },

  methods: {
    handleFilesUploaded({ target: { files } }) {
      if (this.editItem) this.filesUploadedOnEditTodo(files)
      else this.filesUploadedOnCreateTodo(files)
    },

    filesUploadedOnCreateTodo(files) {
      for (const file of files) {
        const { name, size, type } = file
        if (type.includes('image')) {
          const reader = new FileReader()
          reader.onload = ({ target: { result: imageToPreview } }) => {
            this.files.push({ name, size, type, url: imageToPreview, file })
          }
          reader.readAsDataURL(file)
        } else {
          this.files.push({ name, size, type, file })
        }
      }
    },

    filesUploadedOnEditTodo(files) {
      const formData = new FormData()
      if (files.length === 1) formData.append('file', files[0])
      else Array.from(files).forEach((file, index) => formData.append(`files[${index}]`, file))
      apiTo.uploadFile(this.editItem.id, formData).then(({ data }) => {
        if (Array.isArray(data.result)) {
          this.files.push(...data.result)
          this.incrementOrDecrementFilesCount(data.result.length)
        } else {
          this.files.push(data.result)
          this.incrementOrDecrementFilesCount(1)
        }
      })
    },

    deleteFile(index, file) {
      if (this.editItem) {
        apiTo.deleteFile(this.editItem.id, file.id).then(() => {
          this.files.splice(index, 1)
          this.incrementOrDecrementFilesCount(-1)
        })
      } else {
        this.files.splice(index, 1)
        if (file.hasOwnProperty('id')) {
          // the deleted file is from template
          const index = this.filesFromTemplate.findIndex(f => f.id === file.id)
          if (~index) this.filesFromTemplate.splice(index, 1)
        }
      }
    },

    incrementOrDecrementFilesCount(increment) {
      if (this.fromPage === 'kanban') {
        this.$store.commit('kanban-board/incrementOrDecrementFilesCount', {
          todoId: this.editItem.id,
          increment
        })
      }
    },

    getPayload() {
      // access from parent
      return {
        media: this.files.filter(file => !file.hasOwnProperty('id')).map(file => file.file),
        media_from_template: this.filesFromTemplate
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.attachments {
  > .header {
    padding 0
    display grid
    align-items center
    grid-auto-flow column
    justify-content space-between
    margin 5px 0
    width 100%

    > .left {
      display flex
      align-items center
    }
  }
  > .uploaded-files {
    display grid
    grid-template-columns repeat(auto-fit, 100px)
    gap 15px 8px
    background #f5f5f5
    padding 15px
    min-height 100px
  }
}
</style>
